import {createSlice} from "@reduxjs/toolkit";

const slice = createSlice({
        name: "ProductListingAPICall",
        initialState: {},
        reducers: {
           loadData: {
                reducer: (state, action) => { 
                    if (action.payload.data.isFrom === "PLP") {
                     state.data = {
                        ...state.data,
                        ...action.payload,
                        'value': action.payload.data.value || [],
                        '@odata.count': action.payload.data['@odata.count']|| 0,
                        };
                    } else {
                        state.data = {...state.data, ...action.payload.data};
                    }
                    return state
                },
            }
        }
    })
;

export let {loadData} = slice.actions;

export default slice.reducer;
